import { PlayCircle } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { env } from '@/config/env';

// The guide video lives in public/videos and is served by the web host (which
// supports Range requests, so seeking works). The Android build strips it from
// dist (see vite.config.ts) to keep the APK small, so there it streams from the
// same web host that VITE_API_URL points at.
const VIDEO_BASE =
  import.meta.env.MODE === 'android' && /^https?:\/\//.test(env.API_URL)
    ? new URL(env.API_URL).origin
    : '';
const VIDEO_SRC = `${VIDEO_BASE}/videos/pms-guide.mp4`;
const POSTER_SRC = `${VIDEO_BASE}/videos/pms-guide-poster.jpg`;

export function SupportPage() {
  return (
    <div className="mx-auto flex max-w-3xl flex-col gap-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Support</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Watch the PMS walkthrough to learn how to use the system.
        </p>
      </div>

      <Card className="overflow-hidden">
        <CardContent className="flex flex-col gap-4 p-4 md:p-6">
          <div className="flex items-center gap-2 text-sm font-semibold">
            <PlayCircle className="h-4 w-4 text-primary" />
            PMS Guide
          </div>
          <video
            className="mx-auto aspect-[858/1080] w-full max-w-md rounded-lg bg-black"
            src={VIDEO_SRC}
            poster={POSTER_SRC}
            controls
            controlsList="nodownload"
            preload="metadata"
            playsInline
          >
            Your browser can't play this video.
          </video>
        </CardContent>
      </Card>
    </div>
  );
}
